import { Ok, Result } from 'ts-res';
import { KameleoonError } from 'src/kameleoonError';
import { EvaluationDataType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';

export class TargetFeatureFlag implements ICondition {
  private featureId?: number | null;
  private ruleId?: number | null;
  private variationKey?: string | null;

  constructor({ featureFlagId, variationKey, ruleId }: ConditionDataType) {
    this.featureId = featureFlagId;
    this.ruleId = ruleId;
    this.variationKey = variationKey;
  }

  public evaluate({
    variationData,
    ruleMap,
  }: EvaluationDataType): Result<boolean, KameleoonError> {
    if (!this.featureId || !ruleMap) {
      return Ok(false);
    }

    // -- Visitor took part in any experiment of the feature flag
    //    with any variation
    if (this.featureId && !this.ruleId && !this.variationKey) {
      for (const [_, rule] of ruleMap) {
        const { featureId, experimentId } = rule;

        if (
          featureId === this.featureId &&
          typeof variationData[experimentId]?.variationId === 'number'
        ) {
          return Ok(true);
        }
      }

      return Ok(false);
    }

    // -- Visitor took part in certain experiment of the feature flag
    //    with any/exact variation
    if (this.featureId && this.ruleId) {
      const rule = ruleMap.get(this.ruleId);

      if (!rule) {
        return Ok(false);
      }

      const { experimentId, variations } = rule;

      if (this.variationKey) {
        const variationId = variations.get(this.variationKey);

        return Ok(
          Boolean(variationId) &&
            variationData[experimentId]?.variationId === variationId,
        );
      }

      return Ok(Boolean(variationData[rule.experimentId]?.variationId));
    }

    // -- Visitor took part in any experiment of the feature flag
    //    with certain variation
    if (this.featureId && !this.ruleId && this.variationKey) {
      for (const [_, rule] of ruleMap) {
        const { featureId, experimentId, variations } = rule;

        if (featureId === this.featureId && variations.has(this.variationKey)) {
          const variationId = variations.get(this.variationKey);

          return Ok(
            Boolean(variationId) &&
              variationData[experimentId]?.variationId === variationId,
          );
        }
      }
    }

    return Ok(false);
  }
}
